import { render, staticRenderFns } from "./NoApp.vue?vue&type=template&id=33855b77&scoped=true&"
import script from "./NoApp.vue?vue&type=script&lang=js&"
export * from "./NoApp.vue?vue&type=script&lang=js&"
import style0 from "./NoApp.vue?vue&type=style&index=0&id=33855b77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33855b77",
  null
  
)

export default component.exports